import { isProduction } from './env';

export const logger = {
    debug: (message: any, ...optionalParams: any[]) => isProduction ?? console.log(message, optionalParams),
    info: (message: any, ...optionalParams: any[]) => console.log(message, optionalParams),
    error: (message: any, ...optionalParams: any[]) => console.log(new Error(message), optionalParams),
};
